import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ReviewInfoResponse} from "../models/review-info-response";
import {BusinessInfo} from "../models/business-info";
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class GoogleScraperService {

    constructor(private http: HttpClient) {
    }

    getReviewInformation(locationId: string, noOfReviews: number, pageNumber: number) {
        return this.http.get<ReviewInfoResponse>(`${environment.BASE_URL}v2/scraper/getReviewInformation/${locationId}/${noOfReviews}/${pageNumber}`);
    }

    getBusinessInformation(locationId: string) {
        return this.http.get<BusinessInfo>(`${environment.BASE_URL}v2/scraper/getBusinessInformation/${locationId}`);
    }
}
